// The sample data /demo shows, and what a store screenshot photographs.
//
// The generator names demo rows `${Entity} ${n}` — "Task 1", "Task 2", "Task 3"
// — which is honest about being a placeholder and useless as a picture of the
// product. A listing showing an app full of "Task 1" tells a prospective
// installer nothing except that nobody finished it.
//
// These are the plan's own examples, in the plan's own voice: the entity
// describes "changing the air filter, cleaning the gutters, descaling the
// coffee machine", and the name field says to phrase each one as the end of the
// sentence "Last time I…". So the rows read as answers to that.
//
// The DATES matter as much as the names. The screen sorts by how overdue
// something is and prints a plain-language gap, so the sample has to contain a
// genuinely overdue thing, a nearly-due thing, one comfortably in hand and one
// with no schedule at all — otherwise the sorting looks arbitrary and the
// status colours never differ. They are relative to now, so the demo does not
// quietly rot into "4 years ago" on the store listing.

const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};

const monthsAgo = (n) => {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  return d.toISOString();
};

/** Negative ids: demo rows are never persisted to the real store. */
export const DEMO_TASKS = [
  {
    id: -1, entity: 'task', name: 'cleaned the gutters', category: 'Home',
    intervalMonths: 6, notes: 'Ladder is behind the shed. Do the back first.',
    createdAt: monthsAgo(26), archived: false,
  },
  {
    id: -2, entity: 'task', name: 'changed the air filter', category: 'Home',
    intervalMonths: 3, notes: '20x25x1 — the pleated ones, not the fibreglass.',
    createdAt: monthsAgo(18), archived: false,
  },
  {
    id: -3, entity: 'task', name: 'rotated the tyres', category: 'Car',
    intervalMonths: 6, notes: 'Torque to 110 Nm. Chalk the fronts.',
    createdAt: monthsAgo(20), archived: false,
  },
  {
    id: -4, entity: 'task', name: 'descaled the coffee machine', category: 'Appliances',
    intervalMonths: 2, notes: 'Two sachets, then two clean-water cycles.',
    createdAt: monthsAgo(14), archived: false,
  },
  {
    id: -5, entity: 'task', name: 'serviced the smoke alarms', category: 'Home',
    // No interval on purpose: the plan says some things have a history and no
    // schedule, and the screen has to look right for one.
    intervalMonths: 0, notes: 'Three upstairs, two down. 9V, not AA.',
    createdAt: monthsAgo(30), archived: false,
  },
];

export const DEMO_COMPLETIONS = [
  // Badly overdue — every six months, last done fourteen months ago.
  { id: -11, entity: 'completion', task: -1, doneAt: daysAgo(425), note: 'Full of maple seeds again.', loggedAt: monthsAgo(14) },
  { id: -12, entity: 'completion', task: -1, doneAt: daysAgo(620), note: '', loggedAt: monthsAgo(20) },

  // Just overdue — every three months, last done a little over three.
  { id: -13, entity: 'completion', task: -2, doneAt: daysAgo(98), note: 'Filthy. Buy two next time.', loggedAt: monthsAgo(3) },

  // Due soon — every six months, five and a half months ago.
  { id: -14, entity: 'completion', task: -3, doneAt: daysAgo(168), note: '', loggedAt: monthsAgo(5) },

  // Comfortably in hand — every two months, done three weeks ago.
  { id: -15, entity: 'completion', task: -4, doneAt: daysAgo(21), note: 'Water tasted odd beforehand.', loggedAt: daysAgo(21) },

  // No schedule, but a history: this is the "no schedule" row.
  { id: -16, entity: 'completion', task: -5, doneAt: daysAgo(240), note: 'Replaced two batteries.', loggedAt: monthsAgo(8) },
];
